import { schema } from "normalizr";

const wevoResultsSchema = new schema.Entity("wevoResults");

export default wevoResultsSchema;



// WEBPACK FOOTER //
// ./src/schemas/wevo-results.js